import React from 'react';
import './blog2ThyroidFertility.css';

const ThyroidFertilityBlog = () => {
  return (
    <div className="thyroid-blog-container">
      <h1>From Hormones to Health: How Thyroid Disorders Affect Fertility and Pregnancy</h1>
      <p className="thyroid-subheading">A Women’s Health & Fertility Insight Blog by Sukam Speciality Clinic</p>

      <section>
        <h2 className="Introduction">🧬 Introduction: The Butterfly Gland with Mighty Wings</h2>
        <p>
          Tucked at the base of your neck, the thyroid gland may be small in size but plays a monumental role in a woman’s reproductive journey.
          It controls your metabolism, menstrual cycle, ovulation, and even the brain development of your baby during pregnancy.
        </p>
        <p>
          Yet, millions of women suffer in silence from undiagnosed thyroid dysfunctions — leading to irregular periods, fertility issues, pregnancy complications, and even miscarriages.
        </p>
      </section>

      <section>
        <h2>📘 Thyroid: What Does It Do?</h2>
        <p>The thyroid gland produces:</p>
        <ul>
          <li>T3 (Triiodothyronine)</li>
          <li>T4 (Thyroxine)</li>
          <li>Controlled by TSH (Thyroid Stimulating Hormone)</li>
        </ul>
        <p>These regulate:</p>
        <ul>
          <li>🩺 Metabolism and temperature</li>
          <li>🔄 Menstrual cycles and ovulation</li>
          <li>🧠 Brain development in fetus</li>
        </ul>
      </section>

      <section>
        <h2>⚠️ Common Thyroid Disorders in Women</h2>
        <table>
          <thead>
            <tr><th>Type</th><th>Description</th><th>Reproductive Impact</th></tr>
          </thead>
          <tbody>
            <tr><td>Hypothyroidism</td><td>Underactive thyroid</td><td>Irregular cycles, miscarriages</td></tr>
            <tr><td>Hyperthyroidism</td><td>Overactive thyroid</td><td>Cycle disturbance, pregnancy risk</td></tr>
            <tr><td>Subclinical Hypothyroidism</td><td>Normal T4, raised TSH</td><td>Fertility may suffer subtly</td></tr>
            <tr><td>Postpartum Thyroiditis</td><td>After delivery</td><td>Mood swings, affects breastfeeding</td></tr>
            <tr><td>Autoimmune Thyroid</td><td>Hashimoto’s / Graves’</td><td>Infertility, high-risk pregnancy</td></tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>🧪 When Thyroid Affects Fertility</h2>
        <ul>
          <li>❌ Irregular or absent ovulation</li>
          <li>📉 Egg quality & luteal defects</li>
          <li>🤯 Fatigue and low libido</li>
          <li>🤰 Increased miscarriage risk</li>
        </ul>
        <p><strong>Even TSH levels between 2.5 and 4.5 can reduce fertility.</strong></p>
      </section>

      <section>
        <h2>🤰 Thyroid’s Role During Pregnancy</h2>
        <ul>
          <li>🧠 Baby’s brain needs maternal T3/T4 in early weeks</li>
          <li>💔 Uncontrolled hypothyroidism → miscarriage, IUGR, pre-eclampsia</li>
          <li>💥 Hyperthyroidism → fetal tachycardia, low birth weight</li>
        </ul>
      </section>

      <section>
        <h2>🩺 Our Evaluation at Sukam Speciality Clinic</h2>
        <ul>
          <li>✅ TSH, Free T3, Free T4</li>
          <li>✅ Anti-TPO & Anti-thyroglobulin antibodies</li>
          <li>✅ Thyroid ultrasound (if needed)</li>
        </ul>
      </section>

      <section>
        <h2>🧘‍♀️ Treatment Plans – Personalized & Holistic</h2>
        <table>
          <thead>
            <tr><th>Condition</th><th>Management</th></tr>
          </thead>
          <tbody>
            <tr><td>Mild TSH Elevation</td><td>Lifestyle or low-dose thyroxine</td></tr>
            <tr><td>Planning Pregnancy</td><td>Keep TSH &lt; 2.5</td></tr>
            <tr><td>Pregnancy + Thyroid</td><td>Monthly adjustment & monitoring</td></tr>
            <tr><td>Autoimmune Thyroid</td><td>Antibody checks, immune balance</td></tr>
            <tr><td>Postpartum Thyroiditis</td><td>Nutrition + mood support</td></tr>
          </tbody>
        </table>
        <ul>
          <li>🥗 Nutrition + yoga-based plans</li>
          <li>🧘‍♀️ Stress relief + cycle tracking</li>
          <li>🤱 Postpartum care for mother & baby</li>
        </ul>
      </section>

      <section>
        <h2>💬 Real Patient Voices</h2>
        <p><strong>Divya, 32:</strong> “Didn’t know thyroid was the reason for my irregular periods. Now, my cycles are normal and I’m trying to conceive.”</p>
        <p><strong>Haritha, 36:</strong> “TSH of 3.8 was considered ‘normal’ elsewhere. Sukam brought it below 2.5 and I conceived within 3 months.”</p>
      </section>

      <section>
        <h2>🎯 Final Takeaway: Don’t Ignore Your Thyroid</h2>
        <p>
          If you’re struggling with irregular periods, infertility, or miscarriages — don’t overlook your thyroid.
          At Sukam Speciality Clinic, we blend reproductive medicine, endocrinology, and holistic care to restore balance.
        </p>
      </section>
      <p className="cta-blog2">📞 Get tested. Get treated. Let’s restore your hormonal harmony!</p>
    </div>
  );
};

export default ThyroidFertilityBlog;
